<template>
  <div class="sellCenter">
    <div class="inputWrap">
      <div class='headerBox'>
        <el-page-header @back="goBack" content="添加白条"> </el-page-header>
        <div >
           
            <el-button type="info" size='mini' @click="onSubmit">提交添加</el-button>
        </div>
      </div>

      <div class="formBox">
        <div class="formInfo">
          <el-alert
            v-show="showErr.show"
            :title="showErr.text"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <el-form ref="form" :model="form" size="mini" label-width="100px">
          <el-form-item label="数量">
            <el-input-number
              size="mini"
              v-model="form.count"
              @change="countChange"
              :min="1"
              :max="9999"
              label="描述文字"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="产品品种">
            <el-select
              size="mini"
              v-model="form.breed"
              placeholder="请选择品种"
            >
              <el-option
                :key="index"
                v-for="(item, index) in breedData"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="等级">
            <el-select
              size="mini"
              v-model="form.grade"
              placeholder="请选择等级"
            >
              <el-option
                :key="index"
                v-for="(item, index) in gradeData"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="产地">
            <el-select v-model="form.birthPlace" placeholder="请选择产地">
              <el-option
                :key="index"
                v-for="(item, index) in citysArr"
                :label="item.label"
                :value="item.value"
              ></el-option>

              
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="产地:">
            <div class="addressFormItem">
              <div class="addressFormInputItem _cascader">
                <el-cascader
                  v-model="form.birthPlace"
                  :options="citysArr"
                  @change="handleChange"
                ></el-cascader>
              </div>
            </div>
          </el-form-item> -->

          <el-form-item size="mini" label="总重量">
            <div :style="{ width: '185px' }">
              <el-input v-model.number="form.totalWeight">
                <template slot="append">kg</template>
              </el-input>
            </div>
          </el-form-item>

          <div class="addImg">
            <el-form-item label="白条图片" label-width="120px">
              <div class="UploadFileBox">
                <UploadFile
                  :multitude="false"
                  @uploadSuccess="uploadSucces"
                ></UploadFile>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import SparkMD5 from "spark-md5";
import { baseUrl, addMyWhiteBarList, breedData, gradeData } from "@/api/api";

import citys from "@/utils/city.js";
export default {
  props: ["height"],
  data() {
    return {
      form: {
        count: 1,
        breed: "良种猪",
        grade: "1",
        birthPlace:"110000",
        totalWeight: "",
        image: "",
      },
      citysArr: null,
      showErr: {
        show: false,
        text: "",
      },
    };
  },
  created() {
    this.gradeData = gradeData;
    this.breedData = breedData;
    this.citysArr = citys;
    console.log(this.userInfo);
    console.log(this.companyInfo);
  },

  mounted() {},

  computed: {
    ...mapState(["userInfo", "companyInfo"]),
  },
  methods: {
    handleChange(e) {},
    uploadSucces(url) {
      console.log("url", url);
      let form = JSON.parse(JSON.stringify(this.form));
      form.image = url.url;
      this.form = form;
    },
    goBack() {
      this.$router.go(-1);
    },
    countChange(e) {
      // alert(e)
    },
    onSubmit() {
      if (this.testParams(this.form)) {
        console.log(this.form);
        let { count, breed, grade, birthPlace, totalWeight, image } = this.form;

        let { storeId } = this.companyInfo;
        let { access_token } = this.userInfo;

        let subData = {
          count,
          breed,
          grade,
          birthPlace,
          totalWeight,
          image,
          storeId,
          access_token,
        };
        console.log("subData", subData);
        let that = this;
        let url = addMyWhiteBarList;
        let data = subData;
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
              const { data } = res.data;
              console.log(data);
              this.$message({
                message: res.data.resultMsg,
                type: "success",
              });
              setTimeout(() => {
                this.$router.go(-1);
              }, 2000);
            } else {
              console.log(res);
              this.showErr = {
                show: true,
                text: res.data.resultMsg || "添加异常",
              };
            }
          })
          .catch((err) => {
            this.showErr = {
              show: true,
              text: "添加异常",
            };
          });
      }
    },
    testParams(form) {
      // breed,
      // grade,
      // birthPlace,
      // totalWeight: totalWeight.split(" ").join(),
      // image,
      // storeId,
      let showErr = this.showErr;
      if (isNaN(form.count) || !form.count) {
        showErr.show = true;
        showErr.text = "数量格式有误";
        this.showErr = JSON.parse(JSON.stringify(showErr));
        return false;
      }
      if (!form.breed) {
        showErr.show = true;
        showErr.text = "请选择产品品种";
        this.showErr = JSON.parse(JSON.stringify(showErr));
        return false;
      }
      if (!form.birthPlace) {
        showErr.show = true;
        showErr.text = "请选择产品产地";
        this.showErr = JSON.parse(JSON.stringify(showErr));
        return false;
      }
      if (!form.totalWeight || isNaN(form.totalWeight)) {
        showErr.show = true;
        showErr.text = "请输入有效的总重量";
        this.showErr = JSON.parse(JSON.stringify(showErr));
        return false;
      }
      if (!form.image) {
        showErr.show = true;
        showErr.text = "请上传白条图片";
        this.showErr = JSON.parse(JSON.stringify(showErr));
        return false;
      }

      showErr.show = false;
      showErr.text = "";
      this.showErr = JSON.parse(JSON.stringify(showErr));
      return true;
    },
  },
};
</script>
<style scoped lang="less">
.inputWrap {
  margin: 20px;
}
.formBox {
  margin-top: 50px;
}
.addImg {
  // background-color: red;
  width: 600px;
  height: 200px;
}
.uploadImg {
  width: 130px;
  height: 130px;
  border: 1px solid #bbb;
  margin-left: 10px;
}
.icon-my-up {
  border: 1px solid #bbb;
  height: 130px;
  width: 130px;
  text-align: center;
  line-height: 120px;
  font-size: 26px;
  color: #bbb;
  margin-left: 10px;
  background-color: #f9f9f9;
}
.formInfo {
  width: 300px;
  margin-bottom: 20px;
}
.UploadFileBox {
  display: inline-block;
}
.headerBox{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/AddWhitebar.vue